module.exports = __webpack_public_path__ + "static/earth-82751697fc3fbe330bd001c85b3b40af.gif";